import { gql } from '@apollo/client'

export const Query = gql`
  query EditCompany($companyId: ID!) {
    companies(filters: { idEq: $companyId }, first: 1) {
      nodes {
        id
        name
        address1
        address2
        address3
        city
        county
        postcode
        vatNumber
        companyNumber
        phoneNumber
        domain
        email
        locale
        showPricesOnWebsite
        darkLogo { url }
        lightLogo { url }
        placeholderLogo { url }
      }
    }
  }
`
